interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    if (i === 1 || i === totalPages || Math.abs(i - page) <= 1) pages.push(i);
  }

  const items: (number | string)[] = [];
  pages.forEach((item, index) => {
    if (index > 0 && item - pages[index - 1] > 1) items.push(`gap-${item}`);
    items.push(item);
  });

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-1.5" aria-label="分页导航">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line text-base" />
        上一页
      </button>

      {items.map((item) =>
        typeof item === "number" ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            aria-current={item === page ? "page" : undefined}
            className={`h-9 w-9 cursor-pointer rounded-md border text-xs font-semibold transition-colors ${
              item === page
                ? "border-primary-800 bg-primary-800 text-background-50"
                : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={item} className="px-1 text-xs text-foreground-400">
            ···
          </span>
        ),
      )}

      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line text-base" />
      </button>
    </nav>
  );
}